import {createRoot, hydrateRoot} from 'react-dom/client';
import WIMCODigital from '../pages/WIMCODigital/WIMCODigital'
import "../index.css";
import "../pages/WIMCODigital/WIMCODigital.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<WIMCODigital {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <WIMCODigital {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).WIMCODigitalVC = {mount, hydrate, unmount}